import { useEffect, useState } from 'react'
import NameIcon from './shared/NameIcon'
import Spinner from 'app/components/Spinner'
import { gqlFetchOne } from 'app/lib/graphqlClient'
import { bg } from 'lib/background'
import { run } from 'lib/run'

let fetching: Record<string, Promise<{ name: string }>> = {}
let cache: Record<string, { name: string }> = {}

export async function getUserName(userId: string) {
  if (cache[userId] != null) return cache[userId]
  if (fetching[userId] != null) return fetching[userId]
  else if (!userId || userId === `undefined`) return
  return (fetching[userId] = run(async () => {
    const user = await gqlFetchOne<{ name?: string }>('user', userId, 'id name')
    return (cache[userId] = {
      name: user?.name || `Unknown`,
    })
  }))
}

// Legacy getName function for backward compatibility
export async function getName(userId: string) {
  if (cache[userId]?.name != null) return cache[userId].name
  const userData = await getUserName(userId)
  return userData?.name || `Unknown`
}

export function LazyUserCell(props: {
  userId: string
  className?: string
  loadingIndicator?: boolean
  withIcon?: boolean
}) {
  const [user, setUser] = useState<{ name: string } | undefined>(cache[props.userId])

  useEffect(() => {
    if (user && cache[props.userId] === user) return
    else setUser(undefined)
    bg(
      getUserName(props.userId).then((userData) => {
        setUser(userData)
      }),
    )
  }, [props.userId])

  if (!user) {
    return props.loadingIndicator !== false ? <Spinner size={5} /> : null
  }

  if (props.withIcon) {
    return (
      <div className="flex items-center gap-x-2 text-label-xs font-semibold">
        <NameIcon
          fullName={user.name[0]}
          widthClassName="w-6"
          heightClassName="h-6"
          backgroundClassName="bg-[#8009B5]/[0.12]"
          textClassName="text-[#8009B5]"
          borderClassName="border-[0.5px] border-default"
        />
        <div className="text-strong">{user.name}</div>
      </div>
    )
  }

  return <span className={props.className}>{user.name}</span>
}
